import { useGetStatsQuery } from "@/chat-platform/api/nebula-stats/nebulaStatsApi";
import { formatMoneyVND } from "../../utils/nebulaUtils";

const INVESTING_EXPERIENCE_LABELS = {
  0: "Nhà đầu tư mới",
  1: "Nhà đầu tư chủ động",
  2: "Trader chuyên nghiệp",
};

const PortfolioReadyBody = () => {
  const { data: statsData } = useGetStatsQuery({});
  const profile = statsData?.data?.profile;

  return (
    <div className="w-full max-w-[462px] mx-auto">
      <div className="w-full max-w-[358px] mx-auto bg-white border border-[#ececed] rounded-[16px] p-[16px_20px] space-y-[10px]">
        <div className="flex justify-between items-center h-[24px]">
          <span className="text-[16px] leading-[24px] text-[#636369]">
            Chân dung
          </span>
          <span className="text-[16px] leading-[24px] font-medium text-[#111827]">
            {INVESTING_EXPERIENCE_LABELS[profile?.investingExperience] ?? "—"}
          </span>
        </div>
        <div className="h-[1px] bg-[#ececed]" />
        <div className="flex justify-between items-center h-[24px]">
          <span className="text-[16px] leading-[24px] text-[#636369]">
            Vốn đầu tư
          </span>
          <span className="text-[16px] leading-[24px] font-medium text-[#111827]">
            {formatMoneyVND(profile?.capitalAmount)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PortfolioReadyBody;
